"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 13: CPROM (Videomation)
 * ------------------------------------------------------------------ *
 * Simple discrete logic board with 32 KiB PRG-ROM (no banking),
 * 16 KiB CHR-RAM (two 8 KiB RAMs), 4 KiB CHR bank size.
 * Vertical mirroring. Bus conflicts present.
 * Register at $8000-$FFFF: bits 0-1 select 4 KiB CHR RAM bank
 * for PPU $1000-$1FFF. PPU $0000-$0FFF fixed to first 4 KiB page.
 * Used by Videomation.
 * See https://www.nesdev.org/wiki/CPROM
 */

function register(Mappers) {
  Mappers[13] = function (nes) {
    this.nes = nes;
    this.chrBank = 0;
  };

  Mappers[13].prototype = new Mappers[0]();

  Mappers[13].prototype.reset = function () {
    Mappers[0].prototype.reset.apply(this);
    this.chrBank = 0;
  };

  Mappers[13].prototype.write = function (address, value) {
    if (address >= 0x8000) {
      // Bank select register: bits 0-1 select 4 KB CHR RAM bank at $1000
      this.chrBank = value & 0x03;
      this.updateChrBanks();
      return;
    }

    Mappers[0].prototype.write.apply(this, arguments);
  };

  Mappers[13].prototype.updateChrBanks = function () {
    // $0000-$0FFF: fixed to first 4 KB CHR RAM page (bank 0)
    this.load4kVromBank(0, 0x0000);

    // $1000-$1FFF: swappable 4 KB CHR RAM page
    this.load4kVromBank(this.chrBank, 0x1000);
  };

  Mappers[13].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("CPROM: Invalid ROM! Unable to load.");
    }

    this.reset();
    this.loadPRGROM();
    this.loadCHRROM(); // This will set up CHR-RAM
    this.loadBatteryRam();
    this.loadTrainer();
    this.setMirroring(this.nes.rom.VERTICAL_MIRRORING);
    this.resetIrqHandler();
  };

  Mappers[13].prototype.toJSON = function () {
    var s = Mappers[0].prototype.toJSON.apply(this);
    s.chrBank = this.chrBank;
    return s;
  };

  Mappers[13].prototype.fromJSON = function (s) {
    Mappers[0].prototype.fromJSON.apply(this, arguments);
    this.chrBank = s.chrBank;
    this.updateChrBanks();
  };
}

module.exports = { register: register };
